import React from "react";
import "../category_components/product.css"

function Product(props) {
    // Check if image array exists and has elements before accessing properties
    const primaryImg = props.image && props.image.length > 0 && props.image[0].dataAltImage 
                      ? props.image[0].dataAltImage 
                      : '';
                      
    const secondaryImg = props.image && props.image.length > 1 && props.image[1].src 
                        ? props.image[1].src 
                        : (props.image && props.image.length > 0 && props.image[0].src ? props.image[0].src : '');

    const [img, setImg] = React.useState(primaryImg || secondaryImg);
    const [isLoading, setIsLoading] = React.useState(true);
    const [isHovering, setIsHovering] = React.useState(false);

    function handleImageLoad() {
        setIsLoading(false);
    }

    function handleMouseOver() {
        setIsHovering(true);
        // if (secondaryImg) {
        //     setImg(secondaryImg);
        // }
    }

    function handleMouseOut() {
        setIsHovering(false);
        // if (primaryImg) {
        //     setImg(primaryImg);
        // }
    }

    return (
        <a 
            onMouseOver={handleMouseOver} 
            onMouseOut={handleMouseOut} 
            href={`/productpage/${props.slug}`} 
            className="product_div block relative"
        >
            <div className="image_area relative overflow-hidden">
                {isLoading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                        <div className="w-8 h-8 border-2 border-gray-200 border-t-gray-600 rounded-full animate-spin"></div>
                    </div>
                )}
                <img 
                    src={img} 
                    alt={props.name || "Product image"}
                    className={`w-full object-cover transition-opacity duration-300 ease-in-out ${isLoading ? 'opacity-0' : 'opacity-100'}`}
                    onLoad={handleImageLoad}
                    style={{
                        transition: 'transform 0.2s ease-in-out',
                        transform: isHovering ? 'scale(1.02)' : 'scale(1)'
                    }}
                />
            </div>
            <div className="info_area mt-2">
                <p className="font-medium text-pretty line-clamp-2 text-ellipsis ">{props.name}</p>
                <p className="smol text-sm text-gray-600">{props.price}</p>
                <span className="colors flex mt-2 space-x-1">
                    {props.swatches && props.swatches.map((swatch, index) => (
                        <Color
                            key={index}
                            color={swatch.colorCode}
                        />
                    ))}
                </span>
            </div>
        </a>
    );
}
function Color(props){
    var styles = {
        backgroundColor : `${props.color}` 
    }
    return(
        <div style={styles} className="color_div">

        </div>
    )
}

export default Product